import type { ReactNode } from "react";

/**
 * Every user-supplied inline string goes through here. <bdi> isolates its
 * content and picks direction from the first strong character, so a Persian
 * pseudonym in an English admin row (or an English handle in Persian copy)
 * cannot drag surrounding punctuation across the line.
 */
export function Bdi({ children, className }: { children: ReactNode; className?: string }) {
  return <bdi className={className}>{children}</bdi>;
}

/** URLs, emails and phone numbers inside Persian copy: always LTR, isolated. */
export function Ltr({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <span className={`ltr-inline ${className ?? ""}`.trim()} dir="ltr">
      {children}
    </span>
  );
}
